export default __webpack_public_path__ + "static/michalh-8e2556a846a3c6e0a4b5fc08f5084e4f.png";